
import { ChevronDown } from "lucide-react";

interface ScrollToBottomButtonProps {
  show: boolean;
  onClick: () => void;
}

export function ScrollToBottomButton({ show, onClick }: ScrollToBottomButtonProps) {
  if (!show) return null;

  return (
    <div className="relative w-full flex justify-center -mb-5 z-20 pointer-events-none">
      <button
        type="button"
        onClick={onClick}
        className="pointer-events-auto flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-stone-900/95 dark:bg-stone-800/95 text-stone-200 border border-stone-700/80 shadow-2xl backdrop-blur-md hover:bg-stone-800 dark:hover:bg-stone-700 transition cursor-pointer text-xs font-medium"
        title="More text below (Scroll to latest)"
      >
        <span>Latest messages</span>
        <ChevronDown className="w-3.5 h-3.5 animate-bounce" />
      </button>
    </div>
  );
}
